/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import {Breadcrumb, Space} from "antd";
import {Link} from "react-router-dom";
import {ApiTable} from "../components/table";
import {useAppDispatch, useAppSelector} from "../store";
import {openDrawer} from "../reducers/drawers-reducer";
import {Person} from "../core/datamodel";
import {CustomButton} from "../components/buttons";
import {IconSet} from "../components/icons";
import {get} from "../core/request";

export default function PersonListView(props: any) {
    const dispatch = useAppDispatch();

    return (
        <>
            <Breadcrumb style={{paddingTop: 6, paddingBottom: 6}}>
                <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
                <Breadcrumb.Item>Kontakte</Breadcrumb.Item>
            </Breadcrumb>

            <ApiTable
                title={<><IconSet type='persons'/> Kontakte</>}
                id="Persons"
                url="persons"
                reloadSignals={[useAppSelector(state => state.reloadSignals.person)]}
                searchable
                clickable
                buttons={
                <Space
                    size={12}
                >
                    <CustomButton
                        mode={'add'}
                        tooltip={"Neuen Kontakt hinzufügen"}
                        onClick={() => dispatch(openDrawer({key: 'person', object: new Person({})}))}
                    />
                    <CustomButton
                        mode={'export'}
                        tooltip={"Kontaktliste exportieren"}
                        onClick={() => get("persons/export")}
                    />
                </Space>
                }
            />
        </>
    )
}